import { FeatureFlagDefinition } from '.';

export const CALLS_LIVE_MODE_FLAG = 'calls-live-mode';
export const WIDGETS_FLAG = 'widgets';

export const FEATURE_FLAGS: FeatureFlagDefinition[] = [
  {
    key: CALLS_LIVE_MODE_FLAG,
    label: 'Calls live mode',
    description:
      'Shows the Live toggle on call history. While live, the newest calls are polled every 10 seconds, ' +
      'paging and date filters are off, and export is unavailable.',
    defaultValue: false,
  },
  {
    key: WIDGETS_FLAG,
    label: 'Widgets',
    description: 'Shows the Widgets section in the navigation menu.',
    defaultValue: false,
  },
];
